<section class="menufooter">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6 col-lg-3 col-line">
        <h4>Quem Participa</h4>
        <ul class="list-unstyled menufooter-list">
          <li><a (click)="onClickMenu('cidadao')">Cidadão</a></li>
          <li><a (click)="onClickMenu('empresa')">Empresa</a></li>
          <li><a (click)="onClickMenu('instituicao')">Instituição</a></li>
        </ul>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 col-line">
        <h4>Conheça a Campanha</h4>
        <ul class="list-unstyled menufooter-list">
          <li><a (click)="onClickMenu('conheca')">Sobre a Campanha</a></li>
          <li><a (click)="onClickMenu('conheca/como_funciona')">Como funciona</a></li>
          <li><a (click)="onClickMenu('conheca/legislacao')">Legislação</a></li>
          <li><a (click)="onClickMenu('conheca/duvidas_frequentes')">Dúvidas frequentes</a></li>
          <li><a (click)="onClickMenu('conheca/cidadania')">Educação Fiscal</a></li>
        </ul>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 col-line">
        <h4>Sorteios</h4>
        <ul class="list-unstyled menufooter-list">
          <li><a (click)="onClickMenu('sorteios')">Detalhes dos Sorteios</a></li>
          <li><a (click)="onClickMenu('sorteios/informacoes')">Premiação</a></li>
          <li><a (click)="onClickMenu('sorteios/como-funciona-sorteio')">Como funciona</a></li>
          <li><a (click)="onClickMenu('sorteios/pontuacao')">Bilhetes</a></li>
          <li><a (click)="onClickMenu('sorteios/relacao-ganhadores')">Relação de ganhadores</a></li>
        </ul>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 col-line">
        <h4>Contato</h4>
        <ul class="list-unstyled menufooter-list">
          <li><a (click)="onClickMenu('contato')">Fale Conosco</a></li>
        </ul>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/shared-layout/footer/navfooter/navfooter.component.html